import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { createComponent, WidgetComponentConfig } from './widget.component';
import { TranslationKeyMap } from './widget.i18n';
import {
    CMPS_WIDGET_MODAL_HANDLE,
    CMPS_WIDGET_OPTIONS,
} from './widget.metadata';

export interface ModalWidgetComponentRef {
    activeModal: NgbActiveModal;
}

@Component({
    selector: 'cmps-widget-modal',
    templateUrl: './modal.widget.component.html',
})
export class ModalWidgetComponent
    implements AfterViewInit, ModalWidgetComponentRef
{
    @ViewChild('container', { read: ViewContainerRef, static: true })
    container: ViewContainerRef;

    i18n = TranslationKeyMap;
    config: WidgetComponentConfig;

    constructor(
        private readonly _resolver: ComponentFactoryResolver,
        public activeModal: NgbActiveModal,
    ) {}

    ngAfterViewInit(): void {
        const componentRef = createComponent(
            this.config.component,
            this._resolver,
            [
                {
                    provide: CMPS_WIDGET_MODAL_HANDLE,
                    useValue: this,
                },
                {
                    provide: CMPS_WIDGET_OPTIONS,
                    useValue: this.config.options,
                },
            ],
        );
        setTimeout(() => this.container.insert(componentRef.hostView));
    }
}
